import * as React from 'react';
import { Route } from 'react-router-dom';
import { authenticationService } from '../../../webportal/services/authentication';
import { createDefaultApi } from '../../../webportal/utils/createApi';
import { errorHandler } from '../../../webportal/services/errorHandler';

class AdminRoute extends React.Component<any, any> {
    componentDidMount() {
        if (!authenticationService.getWasAuthenticated()) { return; }

        createDefaultApi()
            .then((defaultApi) => {
                return defaultApi.getSettings();
            })
            .catch((error) => {
                errorHandler(error);
            });

    }

    render() {
        const render = (props: any) => {
            const Component: any = this.props.component;
            const webportalComponent = <Component {...props} {...this.props} />;
            return (
                <div className="container">
                    {webportalComponent}
                </div>
            );
        };
        return (
            <Route exact={this.props.exact} render={render} />
        );
    }

}

export { AdminRoute };



// WEBPACK FOOTER //
// ./src/backoffice/components/root/Route.tsx